import type { JSX } from 'react'

export const ArrowDownIcon = (): JSX.Element => (
  <use href='#arrowDownIcon' height='100%' width='100%' />
)
